import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { DatabaseService } from 'src/app/_services/database.service';

@Component({
  selector: 'app-vendor-contact-edit-model',
  templateUrl: './vendor-contact-edit-model.component.html'
})
export class VendorContactEditModelComponent implements OnInit {
  
  constructor(public matdialog:MatDialog, @Inject(MAT_DIALOG_DATA) public data :any ,public db :DatabaseService) { }
  
  ngOnInit() {
    console.log(this.data);
    this.formsInit();
  }
  form: FormGroup;
  
  formsInit() {
    this.form = this.db.formBuilder.group({
      email: [ this.data.email ? this.data.email : '' , [Validators.required,Validators.pattern(/^\w.+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)]],
      mobile: [ this.data.mobile ? this.data.mobile : '' ,[Validators.required,Validators.pattern(/^((\\+91-?)|0)?[0-9]{10}$/)]],
      designation: [ this.data.designation ? this.data.designation : '' ,[Validators.required]],
      name: [ this.data.name ? this.data.name : '' , [Validators.required]],
      contact_id: [this.data.id ? this.data.id : null],
      vendor_id: [this.data.vendor_id ? this.data.vendor_id : null],
    })
  }
  onSubmit(){
    if(this.form.invalid){
      this.form.controls['email'].markAsTouched();
      this.form.controls['name'].markAsTouched();
      this.form.controls['designation'].markAsTouched();
      this.form.controls['mobile'].markAsTouched();
      return
    }
    console.log(this.form.value);
    let reqdata 
    if(this.data.contact_id){
      reqdata = this.form.value
    }else{
      reqdata = {
        vendor_id:this.data.vendor_id,
        contactDetail:[this.form.value]
      } 
    }
    this.db.presentLoader();
    this.db.postReq( this.data.id ? this.form.value :reqdata , this.data.id ? 'vendor/update_contact_detail' : 'vendor/add_contact_detail').subscribe(resp=>{
      this.db.dismissLoader();
      if(resp['status'] == 'success'){
        this.db.successAlert(resp['status'],resp['message']);
        this.matdialog.closeAll()        
      }else{
if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      this.db.errDismissLoader();
    })
    
  }
  
}
